<template>
  <div
    class="flex box"
    :class="{ 'box--no-right': noRight, 'jcsb': !noRight }"
    :style="headerStyle"
  >
    <!-- 插槽 -->
    <div class="left">
      <slot name="left"></slot>
    </div>
    <div class="middle">
      <slot name="middle"></slot>
    </div>

    <div class="right">
      <slot name="right"></slot>
    </div>
  </div>
</template>

<script>
import { hexToRgb, HOME_DEFAULT_TOP_COLOR } from '@/utils/themeColor'

export default {
  name: "HeadChild",
  props: {
    changeColor: null,
    change: {
      type: Boolean,
      default: true
    },
    /** 无右侧按钮时搜索框占满剩余宽度 */
    noRight: {
      type: Boolean,
      default: false,
    },
    /** 首页顶栏主题色，滚动时叠加透明度 */
    themeColor: {
      type: String,
      default: '',
    },
  },
  data() {
    return {
      transparent: 0,
    };
  },
  components: {},
  methods: {
    onScroll() {
      // 获取当前文档流的 scrollTop
      if (this.change) {
        const scrollTop = document.documentElement.scrollTop || document.body.scrollTop
        this.transparent = scrollTop * 0.01
      }

    },

  },
  mounted() {
    // 监听滚动事件
    window.addEventListener('scroll', this.onScroll, false)
  },
  computed: {
    headerStyle() {
      const alpha = this.transparent
      if (this.changeColor) {
        return { backgroundColor: `rgba(255, 150, 105, ${alpha})` }
      }
      const rgb = hexToRgb(this.themeColor || HOME_DEFAULT_TOP_COLOR)
      return { backgroundColor: `rgba(${rgb.r}, ${rgb.g}, ${rgb.b}, ${alpha})` }
    },
  },
  watch: {},
  destroy() {
    // 必须移除监听器，不然当该vue组件被销毁了，监听器还在就会出错
    window.removeEventListener('scroll', this.onScroll)
  },
};
</script>

<style lang='scss' scoped>
.box {
  background-color: rgb(255, 255, 255, 0);
  padding-right: 0.5rem;
  align-items: center;

  &.box--no-right {
    justify-content: flex-start;
    gap: 0.5rem;
    padding-right: 0.75rem;

    .left {
      width: auto;
      flex-shrink: 0;
      min-width: 0;
      text-align: left;

      &:empty {
        display: none;
        width: 0;
        margin: 0;
        padding: 0;
      }
    }

    .middle {
      flex: 1;
      width: auto;
      min-width: 0;
      text-align: left;

      .van-search {
        padding: 0;
        width: 100%;
      }
    }

    .right {
      display: none;
      width: 0;

      /* 传了 right 插槽内容时（如首页客服入口）才显示，未传时保持隐藏，不影响其它页面 */
      &:not(:empty) {
        display: flex;
        align-items: center;
        justify-content: center;
        width: auto;
        flex-shrink: 0;
      }
    }
  }

  .left {
    width: 18%;
    text-align: center;
  }

  .middle {
    width: 70%;
    min-width: 0;
  }

  .right {
    width: 12%;
    text-align: center;
    flex-shrink: 0;
  }
}
</style>